import { useEffect, useRef, useState } from 'react';

export const useOneTimeConfetti = (caseData) => {
  const prevAllSettledRef = useRef(false);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const allSettled =
      caseData?.clients?.length > 0 &&
      caseData.clients.every(c => c.settlement?.settledAt);

    // 🔥 Trigger ONLY on transition
    if (allSettled && !prevAllSettledRef.current) {
      setShowConfetti(true);
    }

    prevAllSettledRef.current = allSettled;
  }, [caseData]);

  return { showConfetti, setShowConfetti };
};
